import React from 'react';
import { RouteContainer, Top } from './styles';
import { Logo } from '../atoms';

type AuthLayoutProps = {
  children: React.ReactNode;
};

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <RouteContainer>
      <Top>
        <Logo />
      </Top>
      {children}
    </RouteContainer>
  );
};

export default AuthLayout;
